import * as React from "react";
import Button from "../../../components/Button";
import TextField from "../../../components/TextField";

interface IFaqHeader {
    onFilter: (event: React.FormEvent<{}>, newValue: string) => void;
    openDialog: () => void;
    onEdit: () => void;
    getFaqs: () => void;
    canEdit: boolean;
    canCreate: boolean;
    editMode: boolean;
    filterValue?: string;
    t: reactI18Next.TranslationFunction;
}

export const FaqHeader: React.SFC<IFaqHeader> = (props: IFaqHeader) => {

    return (
        <React.Fragment>
            <div>
                {props.canCreate &&
                    <Button
                        label={props.t("FAQ:ADD_FAQ")}
                        labelPosition="after"
                        icon="add"
                        onClick={props.openDialog}
                    />
                }
                {props.canEdit &&
                    <Button
                        icon={props.editMode ? "close" : "pencil"}
                        labelPosition={'after'}
                        label={props.t(props.editMode ? "GLOBAL:STOP_EDITING" : "GLOBAL:START_EDITING")}
                        onClick={props.onEdit}
                    />
                }
                <Button
                    label={props.t("GLOBAL:RELOAD")}
                    labelPosition="after"
                    icon="refresh"
                    onClick={props.getFaqs}
                />
            </div>
            <TextField
                placeholder={props.t("FAQ:FILTER_FAQ")}
                value={props.filterValue}
                onChange={props.onFilter}
            />
        </React.Fragment>
    );
};

export default FaqHeader;



// WEBPACK FOOTER //
// ./src/views/AdminView/FaqTab/FaqHeader.tsx